import * as USER from '@/store/constants/user';

export default {
  [USER.GET_USER]: (state) => {
    return state.user;
  },

  [USER.GET_USER_LIST]: (state) => {
    return state.users;
  }
}


// WEBPACK FOOTER //
// ./src/store/user/getters.js